module.exports = __webpack_public_path__ + "img/hero-ln4.732eccd.jpg";